import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { ReadOnlyMerchant } from "Components/Hunter/Merchants/Detail/ReadOnlyMerchant";
import { MerchantSkeleton } from "Components/Hunter/Merchants/Detail/Tabs/Merchant/MerchantSkeleton";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsCurrentUserHunter } from "Hooks/useIsCurrentUserHunter";
import { Resources, useResource } from "Translations/Resources";
import { getAppUrl } from "Utils/UrlUtils";
import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

export const ReadOnlyMerchantDetailPage = () => {
  const { publicID } = useParams();
  const { data, isLoading, isError } = useGetMerchantQuery(publicID);
  const { t } = useResource();
  const isHunter = useIsCurrentUserHunter();

  if (isLoading) {
    return (
      <Layout isHunter={isHunter}>
        <MerchantSkeleton />
      </Layout>
    );
  }

  if (isError || !publicID || !data || !data?.party) {
    return (
      <Layout isHunter={isHunter}>
        <ErrorText>{t(Resources.Error.MerchantNotSelected)}</ErrorText>
      </Layout>
    );
  }

  return (
    <Layout title={data.party.companyName || undefined} isHunter={isHunter}>
      <PrimaryPaper>
        <ReadOnlyMerchant merchant={data} />
      </PrimaryPaper>
    </Layout>
  );
};

type Props = { children: ReactNode; title?: string; isHunter: boolean };

const Layout = ({ children, title, isHunter }: Props) => {
  const appUrl = getAppUrl();

  return (
    <AuthenticatedLayout
      title={title || ""}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl(isHunter ? "all-merchants" : "merchants"),
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">{children}</div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
